<template>
  <el-container
    class="home-container"
    id="rootchart"
    :style="cssVars"
    v-loading.fullscreen.lock="fullscreenLoading">
    <transition name="el-fade-in">
      <div class="dpi-tip-bar" v-if="showDpiTip">
        <i class="el-icon-warning-outline"></i>
        <span>{{ dpiTip }}</span>
        <i class="el-icon-close dpi-tip-close" @click="showDpiTip = false"></i>
      </div>
    </transition>
    <el-aside :width="asideWidth" class="aside">
      <div class="comTitle">
        <div :class="value ? 'logoLight' : ''"></div>
        <!-- <div class="logoLight"></div> -->
        <!-- <div> -->
        <!-- <img src="@/assets/logo.png" alt=""> -->
        <!-- <img src="https://img.js.design/assets/img/6577c8a2b6bb15c7d5d6b1f8.png#c906fc1929c654d56c61305273c9514c" alt=""> -->
        <!-- </div> -->
        <!-- <div>葱花科技</div> -->
      </div>
      <!-- background-color="#1d1f25" text-color="#b7b7b8"   active-text-color="#333"  -->
      <el-menu
        :default-active="default_active"
        router
        :background-color="menuBackgroundColor"
        :text-color="menutTextColor"
        :active-text-color="menuActiveTextColor">
        <el-menu-item
          @click="saveNavState(item)"
          :index="item.path"
          id="menuItem"
          v-for="item in menuList"
          :key="item.id">
          <i :class="iconsObj[item.id]"></i>
          <span>{{ item.authName }}</span>
        </el-menu-item>
      </el-menu>
      <div v-if="showChat" class="btn-chat" @click="show_chop_chat = !show_chop_chat">
        开启 ChopChat
      </div>
      <div class="bottomArea">
        <div><i class="el-icon-share"></i> Help</div>
        <div @click="logout" class="logout"><i class="el-icon-edit"></i> Log Out</div>
      </div>
    </el-aside>

    <el-container>
      <el-header class="app-breadcrumb1" height="calc(var(--ROOTFONTFIZE) * (60 / 144))">
        <div v-show="currentRoute == '/dashboard'" class="breadcrumb">Dashboard</div>
        <div v-show="currentRoute == '/marketDynamics'" class="breadcrumb">
          市场动态 |
          <div class="overview">{{ BreadcrumbsName }}</div>
        </div>
        <div v-show="currentRoute == '/financialReport'" class="breadcrumb">
          财报分析 |
          <div class="overview">{{ BreadcrumbsName }}</div>
        </div>
        <div v-show="currentRoute == '/underlyingAssets'" class="breadcrumb">底层资产</div>
        <div v-show="currentRoute == '/valuationAnalysis'" class="breadcrumb">
          估值分析 |
          <div class="overview">{{ BreadcrumbsName }}</div>
        </div>
        <div v-show="currentRoute == '/trendInights'" class="breadcrumb">
          趋势洞察 |
          <div class="overview">{{ BreadcrumbsName }}</div>
        </div>
        <div v-show="currentRoute == '/individualShare'" class="breadcrumb">
          个券分析 |
          <div class="overview">{{ BreadcrumbsName }}</div>
        </div>
        <div v-show="currentRoute == '/individualShare2'" class="breadcrumb">自选REITs</div>
        <div v-show="currentRoute == '/market-newsletter'" class="breadcrumb">
          市场快报 |
          <div class="overview">{{ BreadcrumbsName }}</div>
        </div>
        <div class="right_area">
          <div>
            <!-- <el-button icon="el-icon-search" size="mini" circle></el-button> -->

            <!-- active-color="#e3e5ed" -->
            <!-- width="36" -->
            <el-switch
              class="switchStyle"
              v-model="value"
              inactive-color="#2a4037"
              active-color="#f8f7f5"
              :disabled="switchDisabled"
              @change="fnSwitch">
            </el-switch>
          </div>

          <div>
            <!-- clearable -->
            <el-autocomplete
              class="SsearchStyle"
              v-model="state2"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              :popper-append-to-body="false"
              :trigger-on-focus="true"
              suffix-icon="el-icon-search"
              @select="handleSelect">
            </el-autocomplete>
          </div>

          <div v-if="!show_badge" @click="showDialog(true)">
            <el-tooltip class="item" placement="bottom">
              <div slot="content">更新说明：{{ info.version }}<br />{{ info.date }}</div>
              <i class="el-icon-bell"></i>
            </el-tooltip>
          </div>
          <el-badge v-else :value="1" class="item" @click.native="showDialog(true)">
            <el-tooltip class="item" placement="bottom">
              <div slot="content">更新说明：{{ info.version }}<br />{{ info.date }}</div>
              <i class="el-icon-bell"></i>
            </el-tooltip>
          </el-badge>

          <el-popover
            v-model="showPhoneTip"
            popper-class="phone-tip-popover"
            placement="bottom"
            trigger="manual"
            :width="280">
            <div class="phone-tip-content">
              <span class="phone-tip-text">目前尚未绑定手机号登录方式，请点击用户名后设置</span>
              <i
                class="el-icon-close phone-tip-close"
                @click="
                  showPhoneTip = false;
                  savePhoneTipCloseTime();
                "></i>
            </div>

            <div class="user-area" slot="reference">
              <!-- <div>
              <img
                src="https://img.js.design/assets/img/6318115e8c377c40ed39a4a9.png#eea81afaad56fef55551f8b7ef2aeb3f"
                alt=""
              />
              
               <div> -->

              <!-- <div>

                </div> -->
              <span @click="showPhoneDialog = true">
                {{ nickName }}
              </span>
              <div class="NAMEAREA" @click="showPhoneDialog = true">
                <img v-show="levelName == 'VIP客户'" src="@/assets/vip.png" alt="" />

                <img v-show="levelName == '普通客户'" src="@/assets/putong.png" alt="" />

                <img v-show="levelName == '试用版'" src="@/assets/shiyong.png" alt="" />
              </div>
            </div>
          </el-popover>

          <!-- 修改手机号弹窗 -->
          <el-dialog
            title="修改手机号"
            :visible.sync="showPhoneDialog"
            width="420px"
            custom-class="phone-dialog"
            append-to-body>
            <el-form :model="phoneForm" :rules="phoneRules" ref="phoneFormRef" label-width="90px">
              <el-form-item label="当前手机号">
                <el-input :value="currentPhonenumber" disabled />
              </el-form-item>
              <el-form-item label="新手机号" prop="phonenumber">
                <el-input
                  v-model="phoneForm.phonenumber"
                  placeholder="请输入新手机号"
                  maxlength="11"
                  clearable />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showPhoneDialog = false">取 消</el-button>
              <el-button class="frontBtn" :loading="phoneLoading" @click="handleUpdatePhone"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>

        <!-- </div> -->
        <!-- </div> -->
      </el-header>

      <el-main>
        <div
          draggable="false"
          v-if="showChat"
          class="btn-chat-img"
          title="chonChat"
          :style="{
            right: chatButtonPos.x + 'px',
            top: chatButtonPos.y + 'px',
            transition: isDragging ? 'none' : 'right 0.3s, top 0.3s',
          }"
          @mousedown="handleMouseDown">
          <!-- <img class="chat-img" draggable="false" src="@/assets/btn-chat-img.png" /> -->
          <!-- <canvas
            class="chopchat-ball-canvas"
            id="chopchatBallCanvas"
            width="112"
            height="112"></canvas> -->
          <!-- ChopChat Assistant Ball (Moved to root level) -->
          <div class="chopchat-ball" id="chopchatBall">
            <canvas
              class="chopchat-ball-canvas"
              id="chopchatBallCanvas"
              width="112"
              height="112"></canvas>
            <div class="chopchat-ball-label">ChopChat</div>
            <!-- <div class="chopchat-ball-badge" id="chopchatBadge" style="display: none">0</div> -->
          </div>
        </div>
        <!-- 路由占位符 -->
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-drawer
      title="我是标题"
      :visible.sync="show_chop_chat"
      size="100%"
      :with-header="false"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      custom-class="cust-drawer-page">
      <vue-draggable-resizable
        always_active
        :draggable="false"
        :handles="['ml']"
        axis="x"
        v-bind="draggable_resizable_info">
        <i class="el-icon-close btn-close-chat" @click="show_chop_chat = false"></i>
        <div class="btn-full" style="transform: translateY(-110%)" @click="fullChat">
          <i class="el-icon-zoom-in"></i>
        </div>
        <div class="btn-full">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div
          :style="{
            'margin-left': '50px',
            'background-color': '#fff',
            width: 'calc(100% - 50px)',
            height: '100%',
          }">
          <iframe
            v-if="showChat"
            :src="chat_url"
            :style="{
              display: 'block',
              width: '100%',
              height: '100%',
            }"
            loading="lazy"
            frameborder="0"
            tabindex="0"></iframe>
        </div>
      </vue-draggable-resizable>
    </el-drawer>
  </el-container>
</template>

<script>
/* import VueDraggableResizable from 'vue-draggable-resizable'; */
import VueDraggableResizable from '@/components/Basic/vue-draggable-resizable';

import { mapState, mapActions, mapMutations } from 'vuex';
import { judgeUpdate } from '../utils/util';

import update_info from './dialog/update_info';
import {
  convertToCascaderOptions,
  buildCascaderOptions,
  buildCascaderOptionsByLevels,
} from '../utils/cascader';

export default {
  components: { 'vue-draggable-resizable': VueDraggableResizable },
  inject: ['showUpdateDialog'],
  data() {
    return {
      showDpiTip: false,
      dpiTip: '',
      showChat: true,
      draggable_resizable_info: {
        w: 750,
        minw: 750,
        // 组件不支持maxw
        maxw: 960,
        h: 919,
      },
      chat_url: 'https://chopchat.chopinsight.cn/?hide=true',
      chat_url_full: 'https://chopchat.chopinsight.cn/',
      show_chop_chat: false,
      info: Object.assign(update_info[0]),
      show_badge: false,
      fullscreenLoading: false,
      value: 1,
      currentRoute: '',

      state2: '',
      searchdata: [
        // {
        //   address: "3.714",
        //   value: "张江光大(508000)",
        //   state: "-0.35%",
        // },
      ],

      menuList: Object.freeze([
        {
          id: 1,
          authName: 'Dashboard',
          path: 'dashboard',
        },
        {
          id: 8,
          authName: '市场快报',
          path: 'market-newsletter',
        },
        {
          id: 2,
          authName: '市场动态',
          path: 'marketDynamics',
        },
        {
          id: 3,
          authName: '底层资产',
          path: 'underlyingAssets',
        },
        {
          id: 4,
          authName: '财报分析',
          path: 'financialReport',
        },
        {
          id: 5,
          authName: '估值分析',
          path: 'valuationAnalysis',
        },
        {
          id: 6,
          authName: '趋势洞察',
          path: 'trendInights',
        },
        {
          id: 7,
          authName: '个券分析',
          path: 'individualShare2',
        },
      ]),

      fromPath: '',

      iconsObj: Object.freeze({
        1: 'iconfont icon-cangku_kucun_o',
        2: 'iconfont icon-shichangdongtai',
        8: 'el-icon-s-order',
        3: 'iconfont icon-zichanguanli-',
        4: 'iconfont icon-caibao',
        5: 'iconfont icon-guzhixitong',
        6: 'iconfont icon-qushi',
        7: 'iconfont icon-gegu',
      }),
      //动态绑定路径
      activePath: '',
      roleName: '',
      roleGender: '',

      // 工作模式导航切换
      bWorkModel: true,

      default_active: '',

      BreadcrumbsName: '概览',

      ROOTFONTFIZE: 0,
      asideWidth: '',

      levelName: '',
      nickName: '',

      menuBackgroundColor: '',
      menutTextColor: '',
      menuActiveTextColor: '',

      switchDisabled: false,
      isActiveBeforeName: false,

      // 修改手机号
      showPhoneDialog: false,
      phoneLoading: false,
      currentPhonenumber: '',
      phoneForm: {
        phonenumber: '',
      },

      // 未绑定手机号气泡提醒
      showPhoneTip: false,
      phoneTipTimer: null,
      phoneRules: {
        phonenumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号', trigger: 'blur' },
        ],
      },

      // 拖拽相关状态
      chatButtonPos: {
        x: 0,
        y: 130,
      },
      isDragging: false,
      dragStartTime: 0,
      dragStartPos: {
        x: 0,
        y: 0,
      },
      longPressTimer: null,
      hasMoved: false,
    };
  },
  created() {
    this.value = localStorage.getItem('Theme') == 'light' ? true : false;
    this.fnSwitch(this.value);
    this.fnInitSearchData();
    this.fnPromiseOrder();
    // this.fnGetCodeName();
    this.fnGetBenchMark();
    this.fnGetLevelList();
    this.fnGetLevelInfo();
    this.fnGetBenchMark2();
    this.fnGetFinData();
    this.fnSetCategory();
    this.fnGetBenchMarkAndBentype();
    this.fnGetCustomColor();
    this.fnGetCustomColor2();
    this.fnGetCustomColorBenchMark();

    // 在created阶段请求左侧数据
    //在页面刷新时,赋值给路径
    const path = window.sessionStorage.getItem('activePath');
    const route_path = this.$route.path.slice(1);
    this.currentRoute = '/' + (path || route_path);
    this.default_active = path || route_path;

    // setTimeout(()=>{

    // },500)

    //  this.searchdata = []

    this.$eventBus.$on('skipPage', (data) => {
      // 之前的路由
      let activeName = localStorage.getItem('activeName');
      localStorage.setItem('activebeforeName', activeName);
      this.isActiveBeforeName = true;
      this.handleSelect(data, true);
    });
    this.$eventBus.$on('updateSwitch', (data) => {
      this.switchDisabled = data;
    });
  },
  mounted() {
    const show_badge = judgeUpdate();
    this.show_badge = show_badge;
    this.showDialog(show_badge);
    this.$eventBus.$on('setBreadcrumbs', (data) => {
      this.fnGetBreadcrumbsName(data);
    });
    this.getCategoryColor();

    this.fnGetWidth();
    window.addEventListener('resize', this.fnGetWidth);

    window.addEventListener('popstate', this.fnBackButton);

    // 加载按钮位置并添加全局事件监听
    this.loadChatButtonPosition();
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
    this._initBallCanvas();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fnGetWidth);
    window.removeEventListener('popstate', this.fnBackButton);
    this.$eventBus.$off('setBreadcrumbs');
    this.$eventBus.$off('updateSwitch');
    this.$eventBus.$off('skipPage');
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  },
  methods: {
    fullChat() {
      // this.show_chop_chat = false;
      window.open(this.chat_url_full);
    },
    showDialog(show) {
      this.showUpdateDialog(show, () => {
        this.show_badge = false;
      });
    },
    fnBackButton(val) {
      // console.log('home页，点击后退了');
      let menuItem = document.querySelectorAll('#menuItem');
      // menuItem.innerText
      let path = this.fromPath.replace(/\//g, '');

      // let path = window.sessionStorage.getItem("activePath");

      console.log(path, 'path玛莎拉蒂');
      let authName = this.menuList.find((node) => node.path == path).authName;

      let index = null;
      menuItem.forEach((node, idx) => {
        if (node.innerText == authName) {
          index = idx;
        }
      });
      menuItem[index].click();

      if (isActiveBeforeName) {
        let activebeforeName = localStorage.getItem('activebeforeName');
        localStorage.setItem('activeName', activebeforeName);
        this.isActiveBeforeName = false;
      }
    },
    // 获取当前主题
    // fnGetTheme(){
    //   let theme = this.$store.state.theme;
    //   console.log(theme,'主题');
    //   if(theme == 'dark'){
    //     this.menuBackgroundColor = '#3b3d42'
    //     this.menutTextColor = '#b7b7b8'
    //     this.menuActiveTextColor = '#58dee3'
    //   }else{
    //      this.menuBackgroundColor = '#ffffff'
    //     this.menutTextColor = '#594f4f'
    //     this.menuActiveTextColor = 'ffffff'
    //   }
    // },

    // 获取自定义颜色 L1
    async fnGetCustomColor() {
      let tagLevel = 1;

      const res = await this.$https.get(
        'api/chart/chartConfiguration/list?pageNum=1&pageSize=10&tagLevel=' +
          tagLevel +
          '&tagType=reits'
      );
      if (res.data.code !== 200) return this.$message.error(res.data.msg);

      let data = res.data.rows;

      // let data =  [
      //     {
      //         "chartId": "1801886357928427522",
      //         "parentName": "0",
      //         "tagLevel": "1",
      //         "tagName": "公募REITs",
      //         "tagType": "reits",
      //         "tagColor": "#e53d30",
      //         // "tagColor": "#5AE8ED",
      //         "createBy": "admin",
      //         "createTime": "2024-06-15 15:56:00"
      //     },
      //     {
      //         "chartId": "1801886433484619777",
      //         "parentName": "0",
      //         "tagLevel": "1",
      //         "tagName": "产权类",
      //         "tagType": "reits",
      //         "tagColor": "#00A6FF",
      //         "createBy": "admin",
      //         "createTime": "2024-06-15 15:56:18"
      //     },
      //     {
      //         "chartId": "1801886499846897666",
      //         "parentName": "0",
      //         "tagLevel": "1",
      //         "tagName": "经营权类",
      //         "tagType": "reits",
      //         "tagColor": "#85D907",
      //         "createBy": "admin",
      //         "createTime": "2024-06-15 15:56:34"
      //     }
      // ]
      data = data.map((node) => {
        return {
          tagName: node['tagName'],
          tagColor: node['tagColor'],
        };
      });

      this.$store.commit('setColor', data);
    },
    // 获取自定义颜色 L2
    async fnGetCustomColor2() {
      let tagLevel = 2;

      const res = await this.$https.get(
        'api/chart/chartConfiguration/list?pageNum=1&pageSize=10&tagLevel=' +
          tagLevel +
          '&tagType=reits'
      );
      if (res.data.code !== 200) return this.$message.error(res.data.msg);

      let data = res.data.rows;

      data = data.map((node) => {
        return {
          tagName: node['tagName'],
          tagColor: node['tagColor'],
        };
      });
      this.$store.commit('setColor2', data);
    },

    // 获取自定义颜色 L2
    async fnGetCustomColorBenchMark() {
      let tagType = 'benchmark';

      const res = await this.$https.get(
        'api/chart/chartConfiguration/list?pageNum=1&pageSize=10&tagType=' + tagType
      );
      if (res.data.code !== 200) return this.$message.error(res.data.msg);

      let data = res.data.rows;

      data = data.map((node) => {
        return {
          tagName: node['tagName'],
          tagColor: node['tagColor'],
        };
      });

      this.$store.commit('setColor3', data);
    },

    // 获取当前屏幕宽度
    fnGetWidth() {
      const maxw = document.body.clientWidth / 2;
      const w = maxw < 750 ? maxw * 0.7 : 750;
      this.draggable_resizable_info = {
        w,
        h: document.body.clientHeight,
        x: document.body.clientWidth - Math.min(750, w),
        minw: w,
        maxw,
      };
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE =
        ROOTFONTFIZE < 1440 ? Number(ROOTFONTFIZE) - 200 - (1440 - ROOTFONTFIZE) : ROOTFONTFIZE;

      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;

      let OFFSETHEIGHT = element.offsetHeight;
      let TABPANEHEIGHT = OFFSETHEIGHT - 135;
      // this.OFFSETHEIGHT = OFFSETHEIGHT;
      localStorage.setItem('ROOTFONTFIZE', ROOTFONTFIZE / 10);
      localStorage.setItem('OFFSETHEIGHT', OFFSETHEIGHT);
      localStorage.setItem('TABPANEHEIGHT', TABPANEHEIGHT);
      sessionStorage.setItem('ROOTFONTFIZE', this.ROOTFONTFIZE);
      document.body.style = `--ROOTFONTFIZE:${this.ROOTFONTFIZE}px`;
      // asideWidth
      // width: calc(var(--ROOTFONTFIZE) * (500 / 96)) ;

      let screenRatio = localStorage.getItem('screenRatio');
      screenRatio = Number(screenRatio) / 100;

      this.asideWidth = this.ROOTFONTFIZE * (224 / 144) + 'px';

      // 检测高DPI模式，显示缩放提示
      const route = this.$route.path;
      if (!['/dashboard', '/individualShare2'].includes(route)) {
        var dpr = window.devicePixelRatio || 1;
        if (dpr >= 1.25 && dpr <= 1.6) {
          if (dpr < 1.4) {
            this.dpiTip =
              '当前系统缩放比例为 125%，建议将浏览器缩放调整为80%以获得最佳浏览体验(修改后刷新页面)';
          } else {
            this.dpiTip =
              '当前系统缩放比例为 150%，建议按 "Ctrl" + "-" 将浏览器缩放调整为70%以下以获得最佳浏览体验(修改后刷新页面)';
          }
          this.showDpiTip = true;
        } else {
          this.showDpiTip = false;
          this.dpiTip = '';
        }
      }

      return;

      // console.log(this.OFFSETWIDTH,'OFFSETWIDTH');
      // let OFFSETWIDTH = element.offsetWidth;
      // this.OFFSETHEIGHT= element.offsetHeight;
      // element.style['min-height']= (OFFSETWIDTH * 0.625)+'px'
      // // element.style.height= '1200px'

      // console.log(this.OFFSETHEIGHT,'OFFSETHEIGHT');

      // rootfontsize
      let rootfontsize = OFFSETWIDTH / 1920;
      this.rootfontsize = rootfontsize;
      console.log(rootfontsize, 'rootfontsize');

      // var loginArea = document.getElementById("loginArea");
      // loginArea.style.width= (OFFSETWIDTH * 555 / 1920)+'px'

      // var element2 = document.getElementById("leftArea");
      // var width2 = element2.offsetWidth;
      // // element2.style.height= (width * 0.77)+'px'
      // element.style.height= (width * 0.67)+'px'
      // element2.style.height= (width2 * 0.77)+'px'
    },

    // 获取搜索选项
    fnGetSearchData(data) {
      //  let DATA123 = JSON.parse(localStorage.getItem("CODELIST"));
      // console.log(DATA123,'DATA123');
      this.searchdata = data.map((node) => {
        let obj = {
          address: '3.714',
          state: '-0.35%',
          value: node.reitsName + '(' + node.reitCode + ')',
        };

        return obj;
      });
    },
    async getCategoryColor() {
      const res = await this.$https.get('api/category/colors');
      if (res.data.data) {
        this.$store.commit('setColors', res.data.data);
      }
    },

    async fnPromiseOrder() {
      await this.fnGetOrder();
      await this.fnGetCodeName();
      await this.fnGetCodeName2();
      await this.fnGetYears();
    },

    // 获取排序
    async fnGetOrder() {
      let params = 'types';
      const res = await this.$https.get('/api/pic_label_order?by_type=' + params);

      if (res.data.success !== true) return this.$message.error('获取排序失败！');

      let data = res.data.data;
      data.push('benchmark');
      localStorage.setItem('ORDER', JSON.stringify(data));
    },
    // 获取股票代码
    alldata(data, combos = []) {
      const order = JSON.parse(localStorage.getItem('ORDER'));
      let all_level = data.reduce(
        (p, c) => {
          p.L0.push(c.reitsTypeL0);
          p.L0_v.push(c.reitsTypeL0_value);
          p.L1.push(c.reitsTypeL1);
          p.L1_v.push(c.reitsTypeL1_value);
          p.L2.push(c.reitsTypeL2);
          p.L2_v.push(c.reitsTypeL2_value);
          p.L3.push(c.reitsTypeL3);
          p.L3_v.push(c.reitsTypeL3_value);
          return p;
        },
        {
          L0: [],
          L0_v: [],
          L1: [],
          L1_v: [],
          L2: [],
          L2_v: [],
          L3: [],
          L3_v: [],
        }
      );
      all_level = {
        L0: [...new Set(all_level.L0)],
        L0_v: [...new Set(all_level.L0_v)],
        L1: [...new Set(all_level.L1)],
        L1_v: [...new Set(all_level.L1_v)],
        L2: [...new Set(all_level.L2)],
        L2_v: [...new Set(all_level.L2_v)],
        L3: [...new Set(all_level.L3)],
        L3_v: [...new Set(all_level.L3_v)],
      };

      localStorage.setItem('L1NAME', JSON.stringify(all_level.L1));

      const CLASSIFY = [...all_level.L0_v, ...all_level.L1_v, ...all_level.L2_v];
      /*  const new_CLASSIFY = order.reduce((p, c) => {
        if (CLASSIFY.includes(c)) {
          p.push(c);
        }
        return p;
      }, []); */
      localStorage.setItem('CLASSIFY', JSON.stringify(CLASSIFY));

      const options = buildCascaderOptions(data);
      // 组合板块（综合办公/全市场零售/商业综合体…）不是个券字段，树里本来没有；
      // 后端 chong_config_category 有指数和收益率，这里挂成一组，所有用板块级联的页面都能选到。
      if (Array.isArray(combos) && combos.length > 0) {
        options.push({ label: '组合板块', value: '组合板块', children: combos });
      }
      const new_FINALLYCATEGORYL1 = all_level.L1.map((item) => ({
        label: item,
        value: item,
      }));
      localStorage.setItem('FINALLYCATEGORY', JSON.stringify(options));
      localStorage.setItem('FINALLYCATEGORYL1', JSON.stringify(new_FINALLYCATEGORYL1));

      const new_REITsNAME = convertToCascaderOptions(data);
      // REITsNAME2基于REITsNAME 不能删除
      localStorage.setItem('REITsNAME', JSON.stringify(new_REITsNAME));

      localStorage.setItem('CODELIST', JSON.stringify(data));
      this.$store.commit('setCodeList', data);

      const CODEobj = data.reduce((p, c) => {
        p[c.reitCode] = c.reitsName;
        return p;
      }, {});
      localStorage.setItem('CODEobj', JSON.stringify(CODEobj));
      this.$store.commit('setCodeName', CODEobj);

      let MAP_L2 = data.map((node) => {
        return {
          name: node.reitCode,
          value: node.reitsTypeL2,
        };
      });

      localStorage.setItem('MAP_L2', JSON.stringify(MAP_L2));
    },
    async fnGetCodeName() {
      const { data } = await this.$https.get('api/conghua/basicInfo/list');
      let combos = [];
      try {
        const res = await this.$https.get('api/category/label?get_composite=1&level=COMBO');
        const list = res && res.data && res.data.success && Array.isArray(res.data.data) ? res.data.data : [];
        combos = list
          .filter((c) => c && c.name && Array.isArray(c.codes) && c.codes.length > 0)
          .map((c) => ({ label: c.name, value: c.name }));
      } catch (e) {
        combos = [];
      }
      this.alldata(data, combos);
      this.fnGetSearchData(data);
      return;
      // 排序
      // let order = [
      //   "公募REITs",
      //   "产权类",
      //   "物流仓储",
      //   "产业园",
      //   "租赁住房",
      //   "消费",
      //   "经营权类",
      //   "市政生态",
      //   "能源",
      //   "交通设施",
      //   "benchmark",
      // ];

      let order = JSON.parse(localStorage.getItem('ORDER'));

      // 获取大类
      let L1 = data.map((node) => {
        return node.reitsTypeL1;
      });

      let L2 = data.map((node) => {
        return node.reitsTypeL2;
      });

      L1 = [...new Set(L1)];
      L1.unshift('公募REITs');

      // 存入L1
      localStorage.setItem('L1NAME', JSON.stringify(L1));

      // L2
      L2 = [...new Set(L2)];

      // 分类
      let CLASSIFY = [...L1, ...L2];
      let tmp = [];
      order.forEach((node) => {
        let obj = CLASSIFY.filter((item) => {
          return node == item;
        });
        if (obj.length > 0) {
          tmp.push(obj[0]);
        }
      });
      CLASSIFY = tmp;
      localStorage.setItem('CLASSIFY', JSON.stringify(CLASSIFY));

      L1 = L1.map((node) => {
        let obj = {
          value: node,
          label: node,
        };
        return obj;
      });

      let BIGCATEGORY = [];

      L1.forEach((node) => {
        let children = [];
        data.forEach((item) => {
          if (node.label == item.reitsTypeL1) {
            children.push(item.reitsTypeL2);
          }
        });

        children = [...new Set(children)];
        if (children.length > 0) {
          children = children.map((node) => {
            let obj = {
              value: node,
              label: node,
            };
            return obj;
          });

          let obj2 = {
            value: node.value,
            label: node.label,
            children: children,
          };

          BIGCATEGORY.push(obj2);
        } else {
          BIGCATEGORY.push(node);
        }
      });
      this.fnSetBIGCATEGORY(BIGCATEGORY);

      // let FINALLYCATEGORY = [...BIGCATEGORY]
      // console.log(FINALLYCATEGORY,'xiangzenan');

      // 存入大类
      // localStorage.setItem("BIGCATEGORYNAME", JSON.stringify(BIGCATEGORY));

      // 存入REITs
      let REITs = [...BIGCATEGORY];
      REITs.forEach((node) => {
        if (node.children) {
          node.children.forEach((item) => {
            item.children = [];
            data.forEach((ele) => {
              if (item.label == ele.reitsTypeL2) {
                let obj = {
                  value: ele.reitCode,
                  label: ele.reitsName,
                };
                item.children.push(obj);
              }
            });
          });
        }
      });

      localStorage.setItem('REITsNAME', JSON.stringify(REITs));

      localStorage.setItem('CODELIST', JSON.stringify(data));
      this.fnGetSearchData(data);

      this.$store.commit('setCodeList', data);

      let obj = {};
      data.forEach((ele) => {
        let left = ele.reitCode;
        let right = ele.reitsName;
        obj[left] = right;
      });

      localStorage.setItem('CODEobj', JSON.stringify(obj));

      this.$store.commit('setCodeName', obj);

      // 存 MAP_L2
      let MAP_L2 = data.map((node) => {
        return {
          name: node.reitCode,
          value: node.reitsTypeL2,
        };
      });

      localStorage.setItem('MAP_L2', JSON.stringify(MAP_L2));
    },
    // 获取股票代码2
    async fnGetCodeName2() {
      const res = await this.$https.get('api/conghua/basicInfo/list_width_userdata');

      const data = res.data.data;
      const data2 = data.filter((item) => item.reitsTypeL1 === '我的自选');

      const result = buildCascaderOptionsByLevels(data2, ['reitsTypeL1', 'reitsTypeL2'], {
        labelField: 'reitsName',
        valueField: 'reitCode',
      });
      const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME'));
      localStorage.setItem('REITsNAME2', JSON.stringify([...REITsNAME, ...result]));
      return;
      // 获取大类
      let L1 = data.map((node) => {
        return node.reitsTypeL1;
      });

      L1 = [...new Set(L1)];
      L1.unshift('公募REITs');
      L1 = L1.map((node) => {
        let obj = {
          value: node,
          label: node,
        };
        return obj;
      });

      let BIGCATEGORY = [];

      L1.forEach((node) => {
        let children = [];
        data.forEach((item) => {
          if (node.label == item.reitsTypeL1) {
            children.push(item.reitsTypeL2);
          }
        });

        children = [...new Set(children)];
        if (children.length > 0) {
          children = children.map((node) => {
            let obj = {
              value: node,
              label: node,
            };
            return obj;
          });

          let obj2 = {
            value: node.value,
            label: node.label,
            children: children,
          };

          BIGCATEGORY.push(obj2);
        } else {
          BIGCATEGORY.push(node);
        }
      });

      // 存入REITs
      let REITs = [...BIGCATEGORY];
      REITs.forEach((node) => {
        if (node.children) {
          node.children.forEach((item) => {
            item.children = [];
            data.forEach((ele) => {
              if (item.label == ele.reitsTypeL2) {
                let obj = {
                  value: ele.reitCode,
                  label: ele.reitsName,
                };
                item.children.push(obj);
              }
            });
          });
        }
      });
    },
    //获取近几年的年份
    async fnGetYears() {
      const res = await this.$https.get('/api/v2_5/get_last_5_years');
      const data = res.data.data;
      localStorage.setItem('last_5_years', JSON.stringify(data));
    },

    // 存入大类
    fnSetBIGCATEGORY(data) {
      let dataL1 = JSON.parse(JSON.stringify(data));

      dataL1 = dataL1.map((node) => {
        if (node.children) {
          delete node.children;
        }
        return node;
      });

      // 存入大类
      localStorage.setItem('FINALLYCATEGORY', JSON.stringify(data));
      localStorage.setItem('FINALLYCATEGORYL1', JSON.stringify(dataL1));

      return;
      data.forEach((node) => {
        if (node.children && node.children.children) {
          delete node.children.children;
        }
      });

      data = data.map((node) => {
        if (node.label !== '公募REITs') {
          let obj = {
            label: node.label,
            value: node.value,
          };
          node.children.unshift(obj);
          return node;
        } else {
          return node;
        }
      });
    },

    // 获取BENCHMARK
    async fnGetBenchMark() {
      const res = await this.$https.get('/api/button_benchmark_diff_return');

      if (res.data.success !== true) return this.$message.error('获取BenchMark失败！');

      let data = res.data.data;

      let benchmark = data.map((node) => {
        return {
          value: node,
          label: node,
        };
      });

      localStorage.setItem('BENCHMARKNAME', JSON.stringify(benchmark));
    },

    // 获取BENCHMARK2
    async fnGetBenchMark2() {
      const res = await this.$https.get('/api/button_benchmark_in_market_line');
      if (res.data.success !== true) return this.$message.error('获取BenchMark失败！');

      let data = res.data.data;
      // let data = [
      //   "CN1YR",
      //   "CN2YR",
      //   "CN3YR",
      //   "CN5YR",
      //   "CN10YR",
      //   "US1YR",
      //   "US2YR",
      //   "US3YR",
      //   "US5YR",
      //   "US10YR",
      //   "JP3YR",
      //   "JP5YR",
      //   "JP10YR",
      //   "UK10YR",
      //   "现货黄金",
      //   "现货白银",
      //   "沪深300",
      //   "中证500",
      //   "中证100",
      //   "大宗商品",
      //   "公用指数",
      //   "上证50",
      //   "红利指数",
      //   "深证红利",
      //   "中证新能源指数",
      //   "红利低波100",
      //   "中证红利",
      //   "股息龙头",
      //   "全指公用",
      //   "上证公用",
      //   "高股息策略",
      //   "东证红利低波",
      //   "国企红利",
      //   "sw_公用事业",
      //   "高收益债ETFs(全)CNY",
      //   "sh_十年国债ETF",
      //   "nhf_南华商品指数",
      //   "国证交通运输行业指数",
      //   "运输指数",
      //   "国证物流",
      //   "sw_高速公路",
      //   "绿色能源",
      //   "电力指数",
      //   "国证电力公用事业行业指数",
      //   "sw_电力",
      //   "cni_风光装备",
      //   "sw_物流",
      //   "sw_产业地产",
      //   "cj_园区开发(长江)",
      //   "sw_水务及水治理",
      //   "sw_环保",
      //   "cj_垃圾焚烧(长江)",
      //   "日经225",
      //   "标普500",
      //   "恒生指数",
      //   "恒生地产分类指数",
      //   "道琼斯工业平均",
      // ];

      let benchmark = data.map((node) => {
        return {
          value: node,
          label: node,
        };
      });

      localStorage.setItem('BENCHMARKNAME2', JSON.stringify(benchmark));
    },

    // 获取Benchmark和bentype
    async fnGetBenchMarkAndBentype() {
      const res = await this.$https.get('api/conghua/benchmarkData/simple-list');
      if (res.status !== 200) return this.$message.error('获取BenchMark失败！');

      let data = res.data;
      localStorage.setItem('BENCHMARKNAMEBENTYPE', JSON.stringify(data));
    },

    // 获取报告期
    async fnGetFinData() {
      const { data } = await this.$https.get('api/conghua/finData/list');

      let periodData = data.map((node) => {
        return {
          value: node,
          label: node,
        };
      });

      localStorage.setItem('PERIODDATA', JSON.stringify(periodData));
    },

    // 存入类别选择数组
    fnSetCategory() {
      let data = [
        {
          value: '产权类',
          label: '产权类',
          children: [
            {
              value: '物流仓储',
              label: '物流仓储',
            },
            {
              value: '产业园',
              label: '产业园',
            },
            {
              value: '租赁住房',
              label: '租赁住房',
            },
            {
              value: '消费',
              label: '消费',
            },
            {
              value: '数据中心',
              label: '数据中心',
            },
          ],
        },
        {
          value: '经营权类',
          label: '经营权类',
          children: [
            {
              value: '市政生态',
              label: '市政生态',
            },
            {
              value: '能源',
              label: '能源',
            },
            {
              value: '交通设施',
              label: '交通设施',
            },
          ],
        },
        {
          value: '商业不动产',
          label: '商业不动产',
          children: [
            {
              value: '商业零售',
              label: '商业零售',
            },
            {
              value: '办公',
              label: '办公',
            },
          ],
        },
        {
          value: '公募REITs',
          label: '公募REITs',
        },
      ];

      localStorage.setItem('CATEGORYDATA', JSON.stringify(data));
    },

    //
    async fnGetLevelList() {
      const res = await this.$https.post('api/level/get-level-list');

      if (res.data.code !== 200) {
        this.$message.error(res.data.msg);
        setTimeout(() => {
          this.$router.push('/login');
        }, 2000);
      } else {
        let levelList = JSON.stringify(res.data.data);
        window.sessionStorage.setItem('levelList', levelList);
      }

      //  if (res.data.code !== 200) return
    },

    async fnGetLevelInfo() {
      const res = await this.$https.get('api/system/user/getInfo');
      if (res.data.code !== 200) return this.$message.error(res.data.msg);
      this.$store.commit('setUserInfo', res.data.data.user);

      let levelName = res.data.data.user.levelName;
      let nickName = res.data.data.user.nickName;

      this.levelName = levelName;
      this.nickName = nickName;
      window.sessionStorage.setItem('levelName', levelName);

      // 获取当前手机号
      this.currentPhonenumber = res.data.data.user.phonenumber || '';

      // 检查是否需要显示未绑定手机号提醒
      this.checkPhoneTip(this.currentPhonenumber);
    },

    handleUpdatePhone() {
      this.$refs.phoneFormRef.validate(async (valid) => {
        if (!valid) return;
        this.phoneLoading = true;
        try {
          const res = await this.$https.post(
            'api/system/user/updatePhonenumber?phonenumber=' + this.phoneForm.phonenumber
          );
          if (res.data.code === 200) {
            this.$message.success('手机号修改成功');
            this.currentPhonenumber = this.phoneForm.phonenumber;
            this.showPhoneDialog = false;
            this.phoneForm.phonenumber = '';
            // 绑定手机号后关闭气泡
            this.showPhoneTip = false;
          } else {
            this.$message.error(res.data.msg || '修改失败');
          }
        } catch (e) {
          this.$message.error('请求失败，请重试');
        } finally {
          this.phoneLoading = false;
        }
      });
    },

    checkPhoneTip(phonenumber) {
      if (!phonenumber) {
        // 没有绑定手机号，检查今天是否已关闭过
        const closeTime = localStorage.getItem('phoneTipCloseTime');
        if (closeTime) {
          const today = new Date().toDateString();
          if (closeTime === today) return; // 今天已关闭过
        }
        // 延迟1.5秒显示气泡，避免登录后立即弹出来干扰用户
        this.phoneTipTimer = setTimeout(() => {
          this.showPhoneTip = true;
        }, 1500);
      }
    },

    savePhoneTipCloseTime() {
      localStorage.setItem('phoneTipCloseTime', new Date().toDateString());
    },

    fnGetBreadcrumbsName(data) {
      this.BreadcrumbsName = data;
      // this.BreadcrumbsName = window.sessionStorage.getItem("BreadcrumbsName");
    },

    handleSelect(item, flag) {
      if (!flag) {
        this.state2 = item.value;
        let val = item.value;
        let arr = val.split('(');
        let name = arr[0];
        this.$store.state.CODELIST.forEach((node) => {
          if (node.reitsName == name) {
            name = node.reitsNameSe;
          }
        });
        window.sessionStorage.setItem('CURRENTCODE', arr[1].slice(0, -1));
        window.sessionStorage.setItem('CURRENTNAME', name);
      } else {
        function isNumber(str) {
          return /^\d+$/.test(str);
        }

        if (!isNumber(item[1].split('.')[0])) return;

        let name = item[0];
        this.$store.state.CODELIST.forEach((node) => {
          if (node.reitsName == name) {
            name = node.reitsNameSe;
          }
        });
        window.sessionStorage.setItem('CURRENTCODE', item[1]);
        window.sessionStorage.setItem('CURRENTNAME', name);
      }
      this.$eventBus.$emit('getIndividualShare');

      let menuItem = document.querySelectorAll('#menuItem');
      menuItem[menuItem.length - 1].click();

      this.saveNavState({ path: 'individualShare' });
      this.$router.push('/individualShare');
    },

    fnInitSearchData() {},

    querySearch(queryString, cb) {
      let data = this.searchdata;
      data = data.filter((node) => {
        return node.value.includes(queryString);
      });
      var results = data;
      cb(results);
    },

    async __logout() {
      // const res = await this.$https.get(domainApi + '/logout?_ajax=1')
      // this.judgeState(res)
      // if (res.data.error_code !== 0) return this.$message.error(res.data.msg)
      // this.$message.success(res.data.msg)
      // this.$router.push('/login')
      // 退出就是清除token
      //  let value=this.$cookies.remove('PHPSESSID')
      // console.log(value,'value');
      // this.$cookies.set('PHPSESSID','')
      // let all=this.$cookies.keys()
      // console.log(all,'all');
      //    let val=this.$cookies.get('PHPSESSID')
      // console.log(val,'val');
      // window.sessionStorage.clear();
      // console.log('token');
      // this.$router.push('/login')
    },

    // 点击按钮,切换菜单的折叠
    // toggleCollapse() {
    //   this.isCollapse = !this.isCollapse
    // },
    // //保存路径
    saveNavState(data) {
      let val = window.sessionStorage.getItem('CURRENTCODE');
      if (!val) {
        window.sessionStorage.setItem('CURRENTCODE', '508000.SH');
        window.sessionStorage.setItem('CURRENTNAME', '张江光大');
      }

      window.sessionStorage.setItem('activePath', data.path);
      localStorage.setItem('activeName', 'first');

      this.currentRoute = '/' + data.path;
    },

    logout() {
      this.$cookies.remove(
        'token',
        null,
        '.' + window.location.hostname.split('.').slice(-2).join('.')
      );
      this.$router.push('/login');
    },

    fnSwitch(val) {
      // this.switchDisabled = !this.switchDisabled
      // true - light
      if (val) {
        this.$store.commit('setTheme', 'light');
        localStorage.setItem('Theme', 'light');
        // this.menuBackgroundColor = "#ffffff";
        this.menutTextColor = '#594f4f';
        this.menuActiveTextColor = 'ffffff';
      } else {
        this.$store.commit('setTheme', 'dark');
        localStorage.setItem('Theme', 'dark');
        // this.menuBackgroundColor = "#3b3d42";
        this.menutTextColor = '#b7b7b8';
        this.menuActiveTextColor = '#58dee3';
      }
    },

    // 聊天按钮位置持久化
    loadChatButtonPosition() {
      try {
        const saved = localStorage.getItem('chat_button_position');
        if (saved) {
          const pos = JSON.parse(saved);
          if (typeof pos.x === 'number' && typeof pos.y === 'number') {
            this.chatButtonPos = pos;
          }
        }
      } catch (e) {
        console.warn('Failed to load chat button position:', e);
      }
    },

    saveChatButtonPosition() {
      try {
        localStorage.setItem('chat_button_position', JSON.stringify(this.chatButtonPos));
      } catch (e) {
        console.warn('Failed to save chat button position:', e);
      }
    },

    // 鼠标按下 - 开始拖拽检测
    handleMouseDown(event) {
      // 只响应左键点击
      if (event.button !== 0) return;

      this.isDragging = true;
      this.hasMoved = false;
      this.dragStartTime = Date.now();
      this.dragStartPos = {
        x: event.clientX,
        y: event.clientY,
      };

      // 设置500ms长按检测定时器
      this.longPressTimer = setTimeout(() => {
        this.longPressTimer = null;
      }, 200);
    },

    // 鼠标移动 - 处理拖拽
    handleMouseMove(event) {
      if (!this.isDragging) return;

      // 如果长按时间未到，不处理移动
      if (this.longPressTimer) return;

      const deltaX = this.dragStartPos.x - event.clientX;
      const deltaY = event.clientY - this.dragStartPos.y;

      // 检查是否已移动超过5px（区分点击和拖拽）
      if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
        this.hasMoved = true;

        // 计算按钮尺寸（考虑响应式缩放）
        const buttonSize = 50 * (this.ROOTFONTFIZE / 144);
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        // 边界约束（按钮至少50%在屏幕内）
        const minX = -buttonSize / 2;
        const maxX = screenWidth - buttonSize / 2;
        const minY = 0;
        const maxY = screenHeight - buttonSize;

        const newX = this.chatButtonPos.x + deltaX;
        const newY = this.chatButtonPos.y + deltaY;

        this.chatButtonPos.x = Math.max(minX, Math.min(maxX, newX));
        this.chatButtonPos.y = Math.max(minY, Math.min(maxY, newY));

        // 重置起始位置，实现连续拖拽
        this.dragStartPos = {
          x: event.clientX,
          y: event.clientY,
        };
      }
    },

    // 鼠标抬起 - 结束拖拽
    handleMouseUp() {
      if (!this.isDragging) return;

      // 清除长按定时器
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }

      this.isDragging = false;

      if (!this.hasMoved) {
        // 未移动，视为点击事件
        this.show_chop_chat = !this.show_chop_chat;
      } else {
        // 已拖拽，保存新位置
        this.saveChatButtonPosition();
      }
    },
    _initBallCanvas() {
      const canvas = document.getElementById('chopchatBallCanvas');
      if (!canvas) return;

      const dpr = window.devicePixelRatio || 1;
      const W = 112,
        H = 112;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      const ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);

      const cx = W / 2,
        cy = H / 2,
        R = 28;
      const bs = 5;
      const chars = '01234567890ABCDEF%+.$';

      const blocks = [];
      const half = Math.ceil(R / bs) + 1;
      for (let gy = -half; gy <= half; gy++) {
        for (let gx = -half; gx <= half; gx++) {
          const bx = gx * bs,
            by = gy * bs;
          const dist = Math.sqrt(bx * bx + by * by);
          if (dist > R + bs * 0.3) continue;
          blocks.push({
            bx,
            by,
            dist,
            edge: dist > R - bs * 1.2,
            angle: Math.atan2(by, bx),
            char: chars[Math.floor(Math.random() * chars.length)],
            flipTimer: Math.random() * 0.8,
            flipSpeed: 0.15 + Math.random() * 0.5,
            bright: 0,
            scale: 1,
            sphere: Math.sqrt(Math.max(0, 1 - (dist / R) ** 2)),
          });
        }
      }

      let t = 0;
      const draw = () => {
        ctx.clearRect(0, 0, W, H);
        t += 0.016;
        const la = t * 0.7;
        const pulse = Math.sin(t * 2.5) * 0.12;

        for (const b of blocks) {
          b.flipTimer -= 0.016;
          if (b.flipTimer <= 0) {
            b.char = chars[Math.floor(Math.random() * chars.length)];
            b.flipTimer = b.flipSpeed;
            b.scale = 0.12;
          }
          b.scale += (1 - b.scale) * 0.16;
          let ad = Math.abs(b.angle - la) % (Math.PI * 2);
          if (ad > Math.PI) ad = Math.PI * 2 - ad;
          const spot = Math.max(0, 1 - ad / 1.2) * 0.35;
          const rip = Math.sin(t * 3.5 - b.dist * 0.12) * 0.15;
          b.bright += (b.sphere * 0.8 + rip + spot + pulse - b.bright) * 0.12;
          const br = Math.max(0, Math.min(1, b.bright));
          const h = bs * b.scale,
            x = cx + b.bx - h / 2,
            y = cy + b.by - h / 2,
            g = 0.5;
          const a = br * (b.edge ? 0.5 : 0.75);
          ctx.fillStyle = `rgba(0,${Math.round(160 + br * 70)},${Math.round(180 + br * 50)},${a})`;
          ctx.fillRect(x + g, y + g, h - g * 2, h - g * 2);
          const ca = br * (b.edge ? 0.4 : 0.65);
          ctx.fillStyle = `rgba(0,${Math.round(120 + br * 80)},${Math.round(150 + br * 50)},${ca})`;
          ctx.font = `600 ${Math.round((bs - 1.5) * b.scale)}px "SF Mono","Menlo",monospace`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(b.char, cx + b.bx, cy + b.by);
        }
        this._ballCanvasRaf = requestAnimationFrame(draw);
      };
      draw();
    },
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      // 保存下from地址
      setTimeout(() => {
        this.fromPath = from.path;
      }, 100);
      this.currentRoute = to.path;
    },
  },
  computed: {
    cssVars() {
      return {
        '--ROOTFONTFIZE': this.ROOTFONTFIZE + 'px',
      };
    },
    ...mapState({
      isLogin: (state) => state.isLogin,
      /*  showChat: (state) => {
        const sub_product = state.user_info.sub_product || '';
        return sub_product.indexOf('Chat') >= 0;
      }, */
    }), //等同于==>...mapState(['isLogin']);映射 this.isLogin 为 this.$store.state.isLogin
  },
};
</script>

<style lang="less" scoped>
.dpi-tip-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: #e6a23c;
  color: #fff;
  text-align: center;
  padding: 8px 40px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.dpi-tip-close {
  cursor: pointer;
  margin-left: 16px;
}

/deep/.switchStyle {
  height: calc(var(--ROOTFONTFIZE) * (20 / 144));
  line-height: calc(var(--ROOTFONTFIZE) * (20 / 144));
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  .el-switch__core {
    height: calc(var(--ROOTFONTFIZE) * (20 / 144));
    &::after {
      width: calc(var(--ROOTFONTFIZE) * (16 / 144));
      height: calc(var(--ROOTFONTFIZE) * (16 / 144));
    }
  }
}

/deep/.handle-ml {
  left: 0;
  width: 50px;
  height: 50px;
  margin-top: -25px;
  z-index: 50;
  opacity: 0;
}

/* el-table 滚动条样式 */
// .home_root .home-container_work .bottom::-webkit-scrollbar{
//     width: 13px;
//  }
// .home_root .home-container_work .bottom::-webkit-scrollbar-thumb {
//   border-radius: 5px;
//   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//   background: rgba(0, 0, 0, 0.2);
// }

// :root{
//   --aa:'pink'
// }

// .aaa{
//   width: 500px;
//   height: 20px;
//   background-color: pink;
// }

// .bbb{
//   width: calc(var(--ROOTFONTFIZE) * (500 / 96)) ;
//   height: 20px;
//   background-color: orange;
// }

.home-container {
  height: 100%;
  // min-width: 1700px;
  // min-height: 900px;
  background-color: var(--bigger-card-bgc);
}

.el-header {
  // background-color: #373d41;
}

.el-main {
  background-color: var(--bigger-card-bgc);
  padding: 0 !important;
  // margin-top: 16px;
  // margin-left: 20px;
  // border-radius: 20px;
  margin-top: 16px;
  margin-left: 20px;
  border-radius: 20px;
  height: 100%;
  box-sizing: border-box;
}

.aside {
  // background-color: rgba(29, 31, 37, 1) !important;
  background-color: var(--el-aside-bgc) !important;

  display: flex;
  flex-direction: column;
  align-items: center;
  // padding-top: 26px;
  height: auto;
  padding-top: calc(var(--ROOTFONTFIZE) * (26 / 144));
  overflow-y: hidden;
}

.el-menu {
  border: 0 !important;
  // width: 178px !important ;
  width: calc(var(--ROOTFONTFIZE) * (178 / 144)) !important ;
  background-color: var(--menuBackgroundColor);
  background-color: transparent;
}

.el-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(var(--ROOTFONTFIZE) * (56 / 144));
  // font-size: 16px;
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  font-weight: 400;
  letter-spacing: 0.1px;

  // margin-bottom: 20px;
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
}

.el-menu-item:hover {
  background-color: var(--el-menuitem-hover-bgc) !important;
  border-radius: 8.83px !important;
}

.el-menu-item i {
  // margin-right: 20px;
  // font-size: 18px;
  margin-right: calc(var(--ROOTFONTFIZE) * (20 / 144));
  font-size: calc(var(--ROOTFONTFIZE) * (18 / 144));
  font-weight: 700;
  display: block;
}

/* el-menu 选中背景色修改 */
.home-container .el-menu-item.is-active {
  // background-color: rgba(8, 46, 102, 1) !important;
  // color: rgba(137, 185, 255, 1) !important;

  background-color: var(--el-menuitem-active-bgc) !important;
  color: var(--el-menuitem-active-color) !important;
  border-radius: 8.83px;
}

.comTitle {
  // width: 178px;
  // padding-bottom: 20px;
  width: calc(var(--ROOTFONTFIZE) * (178 / 144));
  padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));

  border-bottom: 1px solid rgba(96, 96, 96, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-bottom: 50px;
  margin-bottom: calc(var(--ROOTFONTFIZE) * (30 / 144));
}

.comTitle div {
  background-image: url('../assets/logo.png');
  background-size: contain;
  width: calc(var(--ROOTFONTFIZE) * (145 / 144));
  height: calc(var(--ROOTFONTFIZE) * (50 / 144));
  background-repeat: no-repeat;
}

.logoLight {
  background-image: url('../assets/logo_light.png') !important;
  //background-image: url("../assets/logo.png") !important;
}

.comTitle img {
  width: 100%;
  height: 100%;
}

.btn-chat {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  padding: 8px 0;
  border-radius: 40px;
  color: #fff;
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  font-weight: 400;
  letter-spacing: 0.1px;
  background: #1c80d3;
  background: linear-gradient(to right, #1c80d3 0%, #59e7ed 100%);
}

.bottomArea {
  // bottom: 20px;
  // width: 178px;
  margin-top: calc(var(--ROOTFONTFIZE) * (30 / 144));
  width: calc(var(--ROOTFONTFIZE) * (178 / 144));
  border-top: 1px solid rgba(97, 97, 97, 1);
}

.bottomArea div {
  color: var(--el-aside-bottom-color);
  // font-size: 14.07px;
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  font-weight: 400;
  letter-spacing: 0.09px;
  display: flex;
  align-items: center;
  // margin-left: 15px;
  margin-left: calc(var(--ROOTFONTFIZE) * (15 / 144));
}

.bottomArea div:nth-child(1) {
  // margin-top: 20px;
  // margin-bottom: 38px;
  margin-top: calc(var(--ROOTFONTFIZE) * (20 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (38 / 144));
}

.bottomArea div i {
  // font-size: 24px;
  // margin-right: 16px;
  font-size: calc(var(--ROOTFONTFIZE) * (24 / 144));
  margin-right: calc(var(--ROOTFONTFIZE) * (16 / 144));
}

// =======================
.app-breadcrumb1 {
  // height: 72px;
  height: calc(var(--ROOTFONTFIZE) * (72 / 144));
  background-color: var(--el-header-bgc);

  padding: 0px 0;
  // padding-left: 20px;
  // margin-left: 20px;
  // border-radius: 20px;

  padding-left: calc(var(--ROOTFONTFIZE) * (20 / 144));
  margin-left: calc(var(--ROOTFONTFIZE) * (20 / 144));
  border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));

  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: space-between;
}

.breadcrumb {
  color: var(--el-header-text-color);
  // font-size: 26px;
  font-size: calc(var(--ROOTFONTFIZE) * (22 / 144));
  font-weight: 600;
  display: flex;
  align-items: center;
}

.right_area {
  display: flex;
  align-items: center;
  // margin-right: 60px;
  margin-right: calc(var(--ROOTFONTFIZE) * (60 / 144));
}

.right_area div:nth-child(1) {
  // margin-right: 32px;
  margin-right: calc(var(--ROOTFONTFIZE) * (32 / 144));
}

.right_area div:nth-child(3) {
  // background-color: #282c38;
  // background-color: #3b3d42;
  // background-color: var(--el-header-inform-color);
  background-color: var(--el-header-SsearchStyle-bgc);
  // width: 36px;
  // height: 36px;
  width: calc(var(--ROOTFONTFIZE) * (36 / 144));
  height: calc(var(--ROOTFONTFIZE) * (36 / 144));
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-right: 20px;
  margin-right: calc(var(--ROOTFONTFIZE) * (20 / 144));
}

.right_area div:nth-child(3) i {
  color: var(--el-header-iconfont-color);
}

.right_area div:nth-child(4) {
  background-color: #282c38;
  background-color: #282c38;
  background-color: var(--el-header-SsearchStyle-bgc);

  // width: 123px;
  // height: 36px;
  width: auto;
  margin: 0 !important;
  // height: calc(var(--ROOTFONTFIZE) * (36 / 144));
  // height: auto;
  height: calc(var(--ROOTFONTFIZE) * (36 / 144));
  line-height: calc(var(--ROOTFONTFIZE) * (36 / 144));

  border-radius: calc(var(--ROOTFONTFIZE) * (18 / 144));
  display: flex;
  justify-content: center;
  align-items: center;

  padding: calc(var(--ROOTFONTFIZE) * (0 / 144)) calc(var(--ROOTFONTFIZE) * (20 / 144));
  font-size: 14px;
  color: var(--el-header-iconfont-color);
}

.right_area div:nth-child(4):hover {
  // cursor: pointer;
}

.user-area {
  cursor: pointer;
  border-radius: calc(var(--ROOTFONTFIZE) * (18 / 144));
  transition: opacity 0.3s;
  // 恢复原来 .right_area div:nth-child(4) 的样式
  background-color: var(--el-header-SsearchStyle-bgc);
  width: auto;
  margin: 0 !important;
  height: calc(var(--ROOTFONTFIZE) * (36 / 144));
  line-height: calc(var(--ROOTFONTFIZE) * (36 / 144));
  display: flex;
  justify-content: center;
  align-items: center;
  padding: calc(var(--ROOTFONTFIZE) * (0 / 144)) calc(var(--ROOTFONTFIZE) * (20 / 144));
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  color: var(--el-header-iconfont-color);
}

.user-area:hover {
  opacity: 0.8;
}

// phone dialog - 主题适配
::v-deep .phone-dialog .el-dialog__header {
  background-color: var(--dialog_header_bgc);
}

::v-deep .phone-dialog .el-dialog__title {
  color: var(--dialog_header_title_color);
  font-weight: 600;
}

::v-deep .phone-dialog .el-dialog__close.el-icon {
  color: var(--dialog_header_icon_color);
}

::v-deep .phone-dialog .el-dialog__body {
  background-color: var(--dialog_body_bgc);
  padding: 20px 30px;
}

::v-deep .phone-dialog .el-form-item__label {
  color: var(--chart_title);
}

::v-deep .phone-dialog .el-input__inner {
  background-color: transparent;
  border-color: #616161;
  color: var(--chart_title);
}

.conghua-light ::v-deep .phone-dialog .el-input__inner {
  border-color: #dcdfe6;
}

::v-deep .phone-dialog .el-input.is-disabled .el-input__inner {
  background-color: rgba(128, 128, 128, 0.1);
  color: var(--chart_title);
}

::v-deep .phone-dialog .el-dialog__footer {
  background-color: var(--dialog_footer_bgc);
}

// 未绑定手机号气泡提醒
.phone-tip-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.phone-tip-text {
  color: var(--warning-color, #e6a23c);
  font-size: 13px;
  flex: 1;
}

.phone-tip-close {
  cursor: pointer;
  color: var(--chart_title, #999);
  font-size: 14px;
  &:hover {
    color: var(--chart_title_hover, #666);
  }
}

// .right_area div:nth-child(4) div:nth-child(1) {
//   width: calc(var(--ROOTFONTFIZE) * (30 / 144));
//   height: calc(var(--ROOTFONTFIZE) * (30 / 144));
//   margin-left: calc(var(--ROOTFONTFIZE) * (6 / 144));
//   position: relative;

// }

// switch=====================================

// search=====================================
.SsearchStyle {
  // background-color: var(--el-header-SsearchStyle-bgc);
  padding: 0 !important;
  margin-right: calc(var(--ROOTFONTFIZE) * (20 / 144));
}

/deep/.SsearchStyle .el-input__inner {
  width: calc(var(--ROOTFONTFIZE) * (317 / 144));
  background-color: var(--el-header-SsearchStyle-bgc) !important;
  border-radius: 18px;
  margin-left: 0 !important;
  height: calc(var(--ROOTFONTFIZE) * (36 / 144));
  line-height: calc(var(--ROOTFONTFIZE) * (36 / 144));
  border: none !important;
  color: var(--el-header-SsearchStyle-color) !important;
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
}

::v-deep .SsearchStyle .el-input__inner::-webkit-input-placeholder {
  // color: #1573fe !important;
  color: var(--el-search-placeholder-color) !important;
}

// /deep/
//   .el-scrollbar.el-autocomplete-suggestion__wrap
//   .el-scrollbar__wrap
//   .el-input__inner {
//   background-color: pink !important;
// }

/deep/.el-input__suffix-inner {
  display: flex !important;
  align-items: center !important;
  color: var(--el-header-iconfont-color);
}

/deep/.el-icon-search {
  line-height: calc(var(--ROOTFONTFIZE) * (40 / 144));
  font-size: calc(var(--ROOTFONTFIZE) * (18 / 144)) !important;
  font-weight: 700 !important;
  margin-right: calc(var(--ROOTFONTFIZE) * (10 / 144)) !important;
  margin-bottom: calc(var(--ROOTFONTFIZE) * (10 / 144)) !important;
}

/deep/.el-icon-bell {
  font-size: calc(var(--ROOTFONTFIZE) * (18 / 144)) !important;
  font-weight: 700 !important;
}

.logout:hover {
  cursor: pointer;
}

.el-main {
  box-sizing: border-box;
}

// /==================================================================================
.overview {
  color: var(--primary-color);
  margin-left: calc(var(--ROOTFONTFIZE) * (8 / 144));
}

.NAMEAREA {
  width: calc(var(--ROOTFONTFIZE) * (70 / 144));
  height: calc(var(--ROOTFONTFIZE) * (20 / 144));
  display: flex;
  align-items: center;
  justify-content: center;
}

.NAMEAREA img {
  width: 100%;
  height: 100%;
}

/deep/ .el-tabs__nav {
  margin-left: 18px;
  margin-top: -10px;
}
/deep/.cust-drawer-page {
  background-color: transparent;
  box-shadow: none;
  .el-drawer__body {
    overflow: hidden;
    position: relative;
    padding-left: 0;
    padding-right: 0;
  }
}

.btn-chat-img {
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  /* right: 0; */ // 改为动态绑定，由chatButtonPos.x控制
  top: 130px;
  // ECharts 会建立自己的画布层；父级必须在图表层之上，子元素的 z-index
  // 才能生效。仍低于抽屉和全屏弹窗。
  z-index: 1000;
  border-radius: 100%;
  width: calc(var(--ROOTFONTFIZE) * (50 / 144));
  height: calc(var(--ROOTFONTFIZE) * (50 / 144));
  --color-text: #e0e0e0;
  --color-text-muted: #999;
  --color-text-faint: #555;
  --color-surface: rgba(22, 33, 62, 0.65);
  --color-border: rgba(255, 255, 255, 0.06);

  /*  .chat-img {
    user-select: none;
    display: block;
    width: 100%;
    height: 100%;
    object-position: 0% 0%;
    object-fit: cover;
  } */
}
.btn-close-chat {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 26px;
  font-weight: bold;
}
.btn-full {
  cursor: pointer;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0px;
  top: 0;
  bottom: 0;
  height: calc(var(--ROOTFONTFIZE) * (50 / 144));
  margin: auto;
  border-radius: calc(var(--ROOTFONTFIZE) * (30 / 144)) 0 0 calc(var(--ROOTFONTFIZE) * (30 / 144));
  padding: 8px 8px 8px 16px;
  background: #1c80d3;
  background: linear-gradient(to right, #1c80d3 0%, #59e7ed 100%);
  .el-icon-arrow-left,
  .el-icon-zoom-in {
    color: #fff;
    font-size: 26px;
    font-weight: bold;
  }
  .el-icon-zoom-in {
    font-weight: normal;
  }
}
</style>

<style lang="less">
.phone-tip-popover {
  background: var(--dialog_body_bgc, #303133) !important;
  border: 1px solid #fff !important;
  border-radius: 12px !important;
  padding: 12px 14px !important;
  box-shadow: 0 4px 16px rgba(255, 255, 255, 0.15) !important;
  min-width: 260px !important;

  .popper__arrow {
    border-bottom-color: #fff !important;
    &::after {
      border-bottom-color: var(--dialog_body_bgc, #303133) !important;
    }
  }

  .phone-tip-text {
    color: #fff !important;
    font-size: 13px;
    line-height: 1.5;
  }

  .phone-tip-close {
    color: #ccc !important;
    font-size: 14px !important;
    flex-shrink: 0;
    &:hover {
      color: #fff !important;
    }
  }
}

.conghua-light .phone-tip-popover {
  background: #fff !important;
  border-color: #1a1a1a !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;

  .popper__arrow {
    border-bottom-color: #1a1a1a !important;
    &::after {
      border-bottom-color: #fff !important;
    }
  }

  .phone-tip-text {
    color: #1a1a1a !important;
  }

  .phone-tip-close {
    color: #666 !important;
    &:hover {
      color: #333 !important;
    }
  }
}
.chopchat-ball {
  pointer-events: none;
  left: 0;
  top: 0;
  // position: fixed;
  // top: 100px;
  // right: 30px;
  width: calc(var(--ROOTFONTFIZE) * (50 / 144));
  height: calc(var(--ROOTFONTFIZE) * (50 / 144));
  border-radius: 50%;
  background: linear-gradient(135deg, #00c9c3 0%, #0094f4 100%);
  box-shadow: 0 6px 20px rgba(0, 201, 195, 0.35);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s ease, opacity 0.3s;
  z-index: 9999;
  user-select: none;
  animation: chopchat-breathe 4s ease-in-out infinite;
}
.chopchat-ball-label {
  pointer-events: none;
  position: absolute;
  bottom: -18px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 9px;
  font-weight: 600;
  color: rgba(0, 148, 244, 0.7);
  letter-spacing: 0.8px;
  white-space: nowrap;
  pointer-events: none;
}
@keyframes chopchat-breathe {
  0%,
  100% {
    box-shadow: 0 4px 12px rgba(0, 201, 195, 0.35), 0 0 0 0 rgba(0, 148, 244, 0.15);
  }
  50% {
    box-shadow: 0 4px 18px rgba(0, 201, 195, 0.5), 0 0 0 10px rgba(0, 148, 244, 0);
  }
}
.chopchat-ball-canvas {
  pointer-events: none;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
}
</style>
